import { formatarMoeda } from '../../../utils/masks';
import type { RespostasEtapa1Candidato } from '../../../models';

interface EtapaPerfilProfissionalProps {
  respostas: RespostasEtapa1Candidato;
  onChange: (campo: keyof RespostasEtapa1Candidato, valor: string) => void;
}

export default function EtapaPerfilProfissional({ respostas, onChange }: EtapaPerfilProfissionalProps) {
  return (
    <>
      <h2 className="mb-6 text-2xl font-bold text-gray-800">Perfil Profissional</h2>
      <div className="space-y-5">
        <div>
          <label className="mb-1 block text-sm font-semibold text-gray-700">Disponibilidade de início *</label>
          <input
            type="text"
            placeholder="Ex.: Imediata, 30 dias, a combinar..."
            className="w-full rounded-xl border-2 border-gray-100 p-3 focus:border-indigo-400 focus:outline-none"
            value={respostas.disponibilidadeInicio ?? ''}
            onChange={(e) => onChange('disponibilidadeInicio', e.target.value)}
          />
        </div>
        <div>
          <label className="mb-1 block text-sm font-semibold text-gray-700">Pretensão Salarial *</label>
          <input
            type="text"
            inputMode="numeric"
            placeholder="R$ 0,00"
            className="w-full rounded-xl border-2 border-gray-100 p-3 focus:border-indigo-400 focus:outline-none"
            value={respostas.pretensaoSalarial ?? ''}
            onChange={(e) => onChange('pretensaoSalarial', formatarMoeda(e.target.value))}
          />
        </div>
      </div>
    </>
  );
}
